<template>
	<div class="popup popup--medium" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title">Добавить ЕТУ</div>
				<div class="popup__close" @click="$emit('close')"></div>
			</div>
			<div class="popup__content">
				<form class="popup__form">
					<div class="info-list">
						<div class="info-list__item">
							<div class="info-item info-item--2">
								<div class="info-item__el">
									<InputSelect :label="'Раздел'" :errors="v$.formData.section.$errors">
										<template #select>
											<Multiselect
												v-model="formData.section"
												:searchable="true"
												:can-clear="false"
												:canDeselect="false"
												:placeholder="'Выберите раздел'"
												:label="'name'"
												:value-prop="'id'"
												no-results-text="Раздел не найден"
												no-options-text="Начните вводить название"
												@select="changeSection"
												:options="list"/>
										</template>
									</InputSelect>
								</div>
								<div class="info-item__el ">
									<InputSelect v-if="subsection?.length" :label="'Подраздел'" :errors="v$.formData.group.$errors">
										<template #select>
											<Multiselect
												v-model="formData.group"
												:can-clear="false"
												:canDeselect="false"
												:placeholder="'Выберите подраздел'"
												:label="'name'"
												:value-prop="'id'"
												no-results-text="Подраздел не найден"
												no-options-text="Начните вводить название"		
												:options="subsection"										
												/>
										</template>
									</InputSelect>
								</div>								
								<div class="info-item__el info-item__el--2">
									<InputSelect :label="'Единица измерения'" :errors="v$.formData.unit.$errors">
										<template #select>
											<Multiselect
												v-model="formData.unit"
												:can-clear="false"
												:canDeselect="false"
												:options="getProductsUnits"
												:placeholder="'Выберите единицу измерения'"
												:label="'name'"
												:value-prop="'id'"
												/>
										</template>
									</InputSelect>
								</div>

								<div class="info-item__el info-item__el--2">
									<InputText :label="'Наименование ЕТУ'" v-model="formData.name"  :errors="v$.formData.name.$errors" :placeholder="'Введите название ЕТУ'" />
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>		
			
			<div class="form__submit">
				<div class="popup__btns">
					<button class="btn btn--color" @click="validateForm">Добавить</button>
				</div>
			</div>
		</div>
		<transition name="modal">
			<ConfirmAddEtuPopup
				v-if="ShowConfirmAddEtuPopupPopup"
				@close="ShowConfirmAddEtuPopupPopup = false"
				@sendForm="sendForm"
				/>
		</transition>
	</div>

</template>
<script>
import { mapGetters, mapActions } from "vuex";
import InputText from "@/components/base/utils/formElements/InputText.vue";
import Multiselect from "@vueform/multiselect/src/Multiselect";
import InputSelect from "@/components/base/utils/formElements/InputSelect.vue";
import ConfirmAddEtuPopup from "@/components/sections/Tenders/CreateEditTender/ConfirmAddEtuPopup.vue";
import Fetch from "@/utils/Fetch";
import objectToFormData from "@/utils/ObjectToFormData";
import { useToast } from "vue-toastification";
import useVuelidate from "@vuelidate/core";
import {required, helpers} from '@vuelidate/validators'
const {withMessage} = helpers


export default {
	name: 'AddEtuPopup',
	emits: ['update:modelValue', 'close'],
	components: { InputText, Multiselect, InputSelect, ConfirmAddEtuPopup },
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	data() {
		return {
			toast: useToast(),
			ShowConfirmAddEtuPopupPopup: false,
			formData: {
				name: '',
				unit: '',
				section: '',
				group: '',
			},
			sectionsList: [],
			subsection: [],
		}
	},
	computed: {
		...mapGetters({
			getProductsUnits: 'products/getProductsUnits',
			list: 'products/getProductGroups',
		})
	},
	async created() {
		await this.requestProductGroups(true);
	},
	methods: {
		async validateForm() {
			const validated = await this.v$.formData.$validate()
			if (!validated) {
				return
			}
			this.ShowConfirmAddEtuPopupPopup = true
		},
		async sendForm() {
			this.ShowConfirmAddEtuPopupPopup = false

			const body = objectToFormData({
				name: this.formData.name,
				unit: this.formData.unit,
				group: this.formData.group
			})

			let response = await Fetch('products/test/add/', {
				method: 'POST',
				body
			})

			if(response.success) {
				this.toast.success('Тестовый ЕТУ успешно добавлен');
				this.$emit('update:modelValue', [response.data])
				this.$emit('close')
			} else {
				this.toast.error(response.message);
			}
		},
		changeSection(value) {
			this.subsection = []
			this.subsection = this.list.find(item => item.id === value)?.children
			this.formData.group =  ''
		},

		...mapActions({
			requestProductGroups: 'products/requestProductGroups',
		})
	},

	validations() {
		return {
			formData: {
				name: {
					required: withMessage("Заполните наименование ЕТУ", required),
				},
				unit: {
					required: withMessage("Выберите единицу измерения", required),
				},
				section: {
					required: withMessage("Выберите раздел", required),
				},
				group: {
					required: withMessage("Выберите подраздел", required),
				},
			}
		}
	},
}
</script>
